<template>
  <img :src="item.url" class="image" />
</template>

<script setup>
defineProps({
  item: Object
})
</script>

<style scoped>
.image {
  width: 100%;
  border-radius: 8px;
}
</style>
